import React, { useRef, type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { DatePicker, FormElement } from 'mailup-web-components'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionOptinDateState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputDateFromProps {
  index: number
}

const InputDateFrom: FC<InputDateFromProps> = ({ index }) => {
  const intl = useIntl()

  const dirty = useRef(false)

  const { dateFrom, dateTo } = useRecoilValue(criterionOptinDateState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const handleChange = (v: any): void => {
    dirty.current = true

    void changeCriterion('dateFrom', v === null ? undefined : v, index)
  }

  const showFeedback = dateFrom === undefined && dirty.current

  return (
    <FormElement
      variant={showFeedback ? 'danger' : undefined}
      feedback={
        showFeedback
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
    >
      <DatePicker
        data-mu-test="input-date-from"
        value={dateFrom}
        maxDate={dateTo !== undefined ? dateTo : new Date()}
        isClearable={false}
        locale={intl.locale}
        callback={handleChange}
        invalid={showFeedback}
      />
    </FormElement>
  )
}

export default InputDateFrom
